import React, { Component, Fragment } from "react";
import { fetchCategoryProducts } from "../api";
import ProductItem from "../components/ProductItem";
import CategoryTree from "../components/CategoryTree";
import style from "./ProductList.module.css";
import { connect } from "react-redux";
import { addQuoteItem } from "../redux/actions";
import { Button } from "react-bootstrap";
import SalesBanner from "../components/SalesBanner";
import SubcategoryItem from "../components/SubcategoryItem";

class ProductList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: [],
      selectedQuoteItems: new Map()
    };
  }

  componentDidMount() {
    this.fetchCategoryProducts();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.fetchCategoryProducts();
    }
  }

  async fetchCategoryProducts() {
    const { items } = await fetchCategoryProducts(
      this.categoryId,
      this.props.customerGroupId,
      this.props.isMsa
    );

    this.setState({
      products: items
    });
  }

  handleSelect = quoteItem => {
    this.setState(prevState => {
      const selectedQuoteItems = new Map(prevState.selectedQuoteItems);
      selectedQuoteItems.has(quoteItem.productId)
        ? selectedQuoteItems.delete(quoteItem.productId)
        : selectedQuoteItems.set(quoteItem.productId, quoteItem);
      return { selectedQuoteItems };
    });
  };

  handleQtyChange = quoteItem => {
    if (this.state.selectedQuoteItems.has(quoteItem.productId)) {
      this.setState(prevState => {
        const selectedQuoteItems = new Map(prevState.selectedQuoteItems);
        selectedQuoteItems.set(quoteItem.productId, quoteItem);
        return { selectedQuoteItems };
      });
    }
  };

  handleAddSelected = () => {
    [...this.state.selectedQuoteItems.values()].forEach(item =>
      this.props.addQuoteItem(item)
    );

    this.props.history.push("/quote");
  };

  get flatCategory() {
    const categories = this.flatCategoryTree(this.props.categoryTree);
    return categories.find(
      c => c.id === this.props.match.params.id
    );
  }

  get pageFormat() {
    const theCategory = this.flatCategory;
    return theCategory ? theCategory.page_format : "grid";
  }

  get isListView() {
    const pageFormat = this.pageFormat;
    return pageFormat === 'list';
  }

  get categoryId() {
    return this.props.match.params.id;
  }

  get categoryName() {
    const theCategory = this.flatCategory;
    return theCategory ? theCategory.name : "";
  }

  flatCategoryTree(categoryTree) {
    return categoryTree.flatMap(category =>
      [category].concat(
        category.children ? this.flatCategoryTree(category.children) : []
      )
    );
  }

  render() {
    return (
      <Fragment>
        <SalesBanner categoryId={this.categoryId} />
        <div className={style.root}>
          <div className={style.tree}>
            <CategoryTree history={this.props.history} />
          </div>

          <div className={style.main}>
            <div className={style.head}>
              <h1 className={style.title}>{this.categoryName}</h1>

              {this.isListView ? (
                <Button
                  className={style.addSelected}
                  onClick={this.handleAddSelected}
                  disabled={this.state.selectedQuoteItems.size === 0}
                >
                  Add Selected to Quote
                </Button>
              ) : null}
            </div>

            {this.isListView && <div />}

            <ul className={this.isListView ? style.list : style.grid}>
              {this.state.products.length > 0 //if(we have products)
              ? this.state.products.map(product => (
                <li className={style.item} key={product.id}>
                  <ProductItem
                    product={product}
                    view={this.isListView ? "list" : "grid"}
                    handleSelect={this.handleSelect}
                    handleQtyChange={this.handleQtyChange}
                    isSelected={this.state.selectedQuoteItems.has(product.id)}
                    history={this.props.history}
                  />
                </li>
              )) 
              : (this.props.categoryTree.find(cat => cat.id === this.categoryId) !== undefined && this.props.categoryTree.find(cat => cat.id === this.categoryId).children !== undefined) //else if(category has children)
              ? this.props.categoryTree.find(cat => cat.id === this.categoryId).children.map(child_cat => (
                <li key={child_cat.id}>                
                  <SubcategoryItem SubcategoryItem={child_cat} view={this.isListView ? "list" : "grid"} />
                </li>
              ))
              : null //else
              }
              
            </ul>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default connect(
  ({ categoryTree, quote }) => ({
    categoryTree,
    isMsa: quote.isMsa,
    customerGroupId: quote.customerGroupId
  }),
  { addQuoteItem }
)(ProductList);
